import React,{useMemo} from 'react';
import PropTypes from 'prop-types';
import { CssBaseline } from '@material-ui/core';
import { createMuiTheme , ThemeProvider as MUIThemeProvider } from '@material-ui/core/styles';
import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';

const ThemeProvider=({ children })=> {

  const themeOptions = useMemo(
    () => ({
      palette: palette.light,
      typography,
      breakpoints,
      shape: { borderRadius: 8 },
    }),
    []
  );

  const theme = createMuiTheme(themeOptions);

  return (
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
export default ThemeProvider;
